<ng-container *transloco="let t; read: 'preparation'">
  <div class="main-content" *ngIf="preparation !== null">
    <app-content-header
      [title]="preparation.exercisename + ': ' + preparation.name"
    ></app-content-header>

    <div class="layout-content">
      <app-close-button></app-close-button>

      <div class="acr-card-body">

        <ng-container *ngIf="isEntitled() === true">
          <app-tab-selector [tabs]="tabs" [active]="activeTab" [docMode]="true" (activeChange)="onTabChanged($event)"></app-tab-selector>
          <app-content-container [element]="element"></app-content-container>
        </ng-container>

        <div *ngIf="isEntitled() !== true" class="not-entitled">
          <fa-icon class="p-pb-4 icon" [icon]="faTrafficLightStop"></fa-icon><br>
          {{ t('messages.no_rights') }}
        </div>

      </div>

    </div>
  </div>

</ng-container>
